import { Component, Injector, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { AppComponentBase } from 'src/app/shared/app-component-base';
import { Country, Details } from 'src/app/shared/models/countries';
import { User } from 'src/app/shared/models/users/users';
import { SharedService } from 'src/app/shared/services/shared.service';
import { UsersService } from 'src/app/shared/services/users.service';
declare var require: any
const Swal = require('sweetalert2')

@Component({
  selector: 'app-complete-user-data',
  templateUrl: './complete-user-data.component.html',
  styleUrls: ['./complete-user-data.component.scss']
})
export class CompleteUserDataComponent extends AppComponentBase implements OnInit{

  countries!: Details[]
  user!: User | any;
  userId!: number
  userForm!: FormGroup
  userValues!: any
  isImgChanged: boolean = false
  selectedImage: string | ArrayBuffer | null = 'assets/images/user/dummy2.png';
  changePassword: boolean = false

  constructor(
    injector: Injector,
    private router: Router,
    private sharedService: SharedService,
    private userService: UsersService, 
    private fb: FormBuilder,
  ) 
  {
    super(injector)
    this.userId = JSON.parse(localStorage.getItem('user')!).user.id
  }

  ngOnInit(): void {
    this.getCountries()
    this.getUser()
    this.createForm()
  }

  getCountries() {
    this.sharedService.getCountries().subscribe((countries: Country) => {
      this.countries = countries.data
    })
  }

  getUser() {
    this.userService.getUser(this.userId).subscribe((user: any) => {
      this.user = user.data
      this.createForm(user)
    })
  }

  createForm(data?: any) {
    this.userForm = this.fb.group({
      full_name: ['', Validators.required],
      full_name_latin: ['', Validators.required],
      email: ['', [Validators.required, Validators.email]],
      phone: [data?.data.phone.substring(3) || '', [Validators.required, Validators.minLength(9), Validators.maxLength(9)]],
      country_id: ['', Validators.required],
      national_id: ['', [Validators.required, Validators.minLength(10), Validators.maxLength(10)]],
      password: ['', Validators.required],
      password_confirmation: ['', Validators.required],
      profile_photo_path: [''],
      address: ['', Validators.required],
      residential_area: [''],
      work_place: [''],
      job_title: [''],
      change_password: [false],
    })
  }
  get f() {
    return this.userForm.controls;
  }

  handleFileInput(event: any) {
    this.isImgChanged = true

    var files = event.target.files as FileList;
    let file = files[0];
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      this.selectedImage = reader.result
      this.userForm.controls['profile_photo_path'].setValue(file);
    };
  }

  validateForm() {
    if (
      !this.userValues.full_name ||
      !this.userValues.full_name_latin ||
      !this.userValues.email ||
      !this.userValues.phone ||
      !this.userValues.address ||
      !this.userValues.country_id ||
      !this.userValues.national_id ||
      (this.changePassword && (!this.userValues.password || !this.userValues.password_confirmation))
      )  {
      this._toastr.error('تأكد من جميع البيانات المطلوبة')
      this.formValid = false
    } else if (this.userValues.phone.length < 9 || this.userValues.phone.length > 9) { 
      this._toastr.error('رقم الهاتف يجب ان يكون 9 ارقام ويبدأ بالرقم 5')
      this.formValid = false
    }
    else if (this.userValues.national_id.length < 10) {
      this._toastr.error('رقم الهوية أقل من 10 أرقام')
      this.formValid = false
    }
    else {
      this.formValid = true
    }
    return this.formValid
  }

  createFormDataValues(values: any) {
    let formData = new FormData() as any
    Object.entries(values).forEach(([key, value]: any) => {
      formData.append(key, value)
    })

    return formData
  }

  save() {
    this.userValues = this.userForm.value as any
    this.formSubmitted = true
    
    let dataToSend = {
      full_name: this.userValues.full_name,
      full_name_latin: this.userValues.full_name_latin,
      email: this.userValues.email,
      phone: '966' + this.userValues.phone,
      country_id: this.userValues.country_id,
      national_id: this.userValues.national_id,
      password: this.userValues.password,
      password_confirmation: this.userValues.password_confirmation,
      profile_photo_path: this.isImgChanged ? this.userValues.profile_photo_path : '',
      address: this.userValues.address,
      // residential_area: this.userValues.residential_area,
      work_place: this.userValues.work_place,
      job_title: this.userValues.job_title,
      accept_terms_flag: "0",
      active: this.active ? 1 : 0
    } as any
    console.log(dataToSend)
    let model = this.createFormDataValues(dataToSend)

    if (this.validateForm()) {
      this.authService.updateParent(model).subscribe(res => {
        this.afterSubmit()
      })
    }
  }

  getName(itemId: any, listType: any) {
    let found: any
    switch (listType) {
      case 'nationality':
        if(this.countries) {
          found = this.countries.find((element) => element.id == itemId);
        }
        break;
      default:
        break;
    }
    return found
  }

  toggleView() {
    
  }

  afterSubmit() {
    this.userForm.reset()
    this.formReseted = true
    this.cancelForm()
    this._toastr.success("تم حفظ البيانات.. برجاء اعادة تسجيل الدخول")
    localStorage.removeItem('user')
    this.router.navigate(['/auth/login'])
  }
}
